import { Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthRoute = ({ element, user }) => {
  const CC = useSelector(state => state.auth.auth);
  const userData = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();
  const messageRoute = location.pathname.startsWith("/messages");
  console.log("show message routes--->", messageRoute);



  if (!CC || !CC.user_type) {
    return <Navigate to="/login"
      state={messageRoute ? { from: location } : null}
      replace />;
  }
  const fallbackPath = CC.user_type === "freelancer" ? "/freelancer-dashboard" : "/dashboard";

  // If user is an array (for commonRoutes), check if user_type exists in the array
  if (Array.isArray(user)) {
    return user.includes(CC.user_type) ? element : <Navigate to={fallbackPath} replace />;
  }

  // For single user roles (empRoutes, lancerRoutes)
  return CC.user_type === user ? element : <Navigate to={fallbackPath} replace />;
};

export default AuthRoute;
